import { isMyLearningCompleted } from "./qmsMyLearningsUtils";
import { getReviewDateStatus } from "./qmsReviewDateUtils";

/** Document Library column filter — Learning progress (server-side). */
export const LIBRARY_LEARNING_PROGRESS_FILTER_OPTIONS = [
  { value: "", label: "All progress" },
  { value: "Unassigned", label: "Unassigned" },
  { value: "Pending", label: "Pending" },
  { value: "Completed", label: "Completed" },
  { value: "Overdue", label: "Overdue" },
];

export function getDocumentLearningStatsFromRow(row) {
  const total = Number(row?.LearningAssignedCount) || 0;
  const completedCount = Number(row?.LearningCompletedCount) || 0;
  const pendingCount =
    Number(row?.LearningPendingCount) ||
    Math.max(0, total - completedCount);
  const completionPct = total > 0 ? Math.round((completedCount / total) * 100) : 0;

  return {
    total,
    completedCount,
    pendingCount,
    completionPct,
  };
}

export function buildDocumentLearningStats(staffRows = [], documentRow = null) {
  const assigned = (staffRows || []).filter(
    (row) => Number(row?.Assigned) === 1 || row?.Assigned === true || row?.StaffId,
  );
  const completed = assigned.filter((row) => isMyLearningCompleted(row));
  const pending = assigned.filter((row) => !isMyLearningCompleted(row));
  const overdue = pending.filter(
    (row) => getStaffLearningStatusKey(row, documentRow) === "overdue",
  );

  const total = assigned.length;
  const completedCount = completed.length;
  const pendingCount = pending.length;

  return {
    total,
    completedCount,
    pendingCount,
    overdueCount: overdue.length,
    completionPct: total > 0 ? Math.round((completedCount / total) * 100) : 0,
    completed,
    pending,
    overdue,
  };
}

export function getStaffLearningStatusKey(staffRow, documentRow) {
  if (isMyLearningCompleted(staffRow)) return "completed";
  const review = getReviewDateStatus(documentRow || staffRow);
  if (review.status === "overdue") return "overdue";
  return "pending";
}

export function getStaffLearningStatusMeta(staffRow, documentRow) {
  const key = getStaffLearningStatusKey(staffRow, documentRow);
  if (key === "completed") {
    return { key, label: "Completed", tone: "success" };
  }
  if (key === "overdue") {
    return { key, label: "Overdue", tone: "danger" };
  }
  return { key, label: "Pending", tone: "warning" };
}

export function filterLearningStaffByStatus(staffRows, statusKey, documentRow) {
  if (!statusKey || statusKey === "all") return staffRows;
  return (staffRows || []).filter(
    (row) => getStaffLearningStatusKey(row, documentRow) === statusKey,
  );
}
